const initialState = {
    topWinners: [],
    otherWinners: [],
    lotteryOptions: [],
    isLoaded: false
};

const reduxLuckyWinner = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_LUCKY_WINNER_DATA_SUCCESS':
            return {
                ...state,
                topWinners: action.payload.topWinners,
                otherWinners: action.payload.otherWinners,
                lotteryOptions: action.payload.lotteryOptions,
                isLoaded: true
            };
        default:
            return state;
    }
};

export default reduxLuckyWinner;
